


const AppliedFiltersTag = ({ id, label, value, oncrossClick }) => {
    const appliedFilterStyle = {
        position: 'relative',
        bottom: '30px',
        left: '-14px',
        cursor: 'pointer',
        border: '0.2px solid rgba(0, 0, 0, 0.4)',
        borderRadius: '2px',
    };

    const crossImage = 'https://cdn.venuemonk.com/cross-icon-grey.svg';

    return (
        <>
            <span
                style={{
                    cursor: 'pointer',
                    background: '#E9D3F7',
                    borderRadius: '4px',
                    display: 'inline-block',
                }}
                className="vm-search-app-filter-btn"
                key={id}
            >
                {`${label}`}
            </span>
            <img
                src={crossImage}
                style={appliedFilterStyle}
                onClick={async () => await oncrossClick(id)}
            />
        </>
    );
};


export default AppliedFiltersTag